const $ = window.jQuery;

class Toast {

    constructor() {
    }

    //#! Class constants
    static get TYPE_INFO() {
        return {
            bgColor: '#cce5ff',
            textColor: '#004085',
        };
    }

    static get TYPE_ERROR() {
        return {
            bgColor: '#f8d7da',
            textColor: '#721c24',
        };
    }

    static get TYPE_SUCCESS() {
        return {
            bgColor: '#d4edda',
            textColor: '#155724',
        };
    }

    show(message, cssClass = 'info') {

        let info = Toast.TYPE_INFO;
        if('error' === cssClass){
            info = Toast.TYPE_ERROR;
        }
        else if('success' === cssClass){
            info = Toast.TYPE_SUCCESS;
        }

        $.toast({
            text: message,
            bgColor: info.bgColor,
            textColor: info.textColor,
            allowToastClose: true,
        });
    }

    hide() {
        $.toast().reset('all');
    }
}

export default Toast;
